import React from "react";
import {connect} from "react-redux";
import {
    Dimensions,
    FlatList,
    KeyboardAvoidingView,
    ScrollView,
    StyleSheet,
    Text,
    TouchableOpacity,
    View
} from "react-native";
import TendancetListItem from "../Tendance/TendancetListItem";
import LexicalSectionList from "../LexicalSectionList/LexicalSectionList";
import BarreRecherche from "../Header/BarreRecherche";
import {getAllContact} from "../../API/API";
import {withTranslation} from "react-i18next";
import {compose} from "redux";
import {wrapAction, wrapStyle} from "../../sw/helpers";
import FocusActivePicto from "../Picto/FocusActivePicto";
import FocusPicto from "../Picto/FocusPicto";
import CheckActivePicto from "../Picto/CheckActivePicto";
import CheckNotActivePicto from "../Picto/CheckNotActivePicto";


class ExplorerContactList extends React.Component{
    constructor(props) {
        super(props);
        //this.offsetY = 0;

        this.state = {
            search:"",
            data : this._formData(this.props.data,""),
	    active_display_list: true
        }
        this.search = this.search.bind(this);
        this._formData = this._formData.bind(this);
    }

    getDimensions() {
      return Dimensions.get('window');
    }

    _getAllContact(){
        getAllContact().then((data)=>{
            this.setState({
                data : this._formData(data)
            })
        });
    }

    _sortData(data){

        return data.sort((a,b)=>{
            let indexA = (this.props.isEntity)? a.name.replace('É','E').toUpperCase() : a.lastname.replace('É','E').toUpperCase();
            let indexB = (this.props.isEntity)? b.name.replace('É','E').toUpperCase() : b.lastname.replace('É','E').toUpperCase();
            if(indexA>indexB){
                return 1;
            }else if(indexA<indexB){
                return -1;
            }else{
                return 0;
            }
        })
    }

    _formData(allData,search){
	// may be called from the constructor
	if (this.state) {
	  // if active_display_list is set (an array), get all from array
	  if (this.props.isUpdate && this.state.active_display_list !== true) {
	    allData = allData.filter((item) => this.state.active_display_list.some(x => x.id == item.id))
	  }
	}

       let data = allData.filter((item)=>{
           if (search === "") return true;
           if (this.props.isEntity) {
             return parseAccent(item.name)?.toUpperCase().includes(search) || parseAccent(item.description)?.toUpperCase().includes(search) || parseAccent(item.label)?.toUpperCase().includes(search) || parseAccent(item.alias)?.toUpperCase().includes(search) ;
           } else {
             return parseAccent(item.lastname)?.toUpperCase().includes(search) || parseAccent(item.firstname)?.toUpperCase().includes(search) || parseAccent(item.biography)?.toUpperCase().includes(search) || parseAccent(item.career)?.toUpperCase().includes(search) ;
           }
        });

        if(data.length===0){
            return [];
        }

        data = this._sortData(data);
        let firstLetter;
        if(this.props.isEntity){
            firstLetter = data[0].name.charAt(0).toUpperCase();
        }else{
            firstLetter = data[0].lastname.charAt(0).toUpperCase();
        }


        let result = [{title : firstLetter,data:[]}];
         data.map((item)=>{
            let itemDescr ;
            if(this.props.isEntity){
                itemDescr = item.name;
            }else{
                itemDescr = item.lastname;
            }
             let itemLetter= itemDescr.charAt(0).toUpperCase().replace('É','E');
            if(firstLetter.toUpperCase()!=itemLetter.toUpperCase()){
                firstLetter = itemLetter;
                result.push({title: firstLetter.toUpperCase(),data:[item]});
            }else{
                result.map((i)=>{
                    if(i.title.toUpperCase() == firstLetter.toUpperCase()){
                        i.data.push(item);
                    }
                });
            }
            return {item :item, value:itemDescr,key:item.id}
        });

        return result;
    }

    search(text){
        this.setState({
           search : text
        });
    }

    renderEmptyContainer(width, height){

        return (<View style={{width:width,height:height,justifyContent:"center",alignItems:"center"}}><Text style={{color:this.props.theme.colors.tertiary.black1.value}}>Aucun élément à afficher</Text></View>)
    }

    renderSelector(styles) {
      const {active_display_list} = this.state;

      const cb = () => {
	if (active_display_list !== true) {
	  this.setState({active_display_list: true})
	} else {
	  const {focusList, focusListSet, notificationList, notificationListSet} = this.props;

	  this.setState({
	    active_display_list: focusList.concat(focusListSet, notificationList, notificationListSet)
	  })
	}
      };

      // true when accepts all (it is not set, should be an array otherwise)
      return <TouchableOpacity style={styles.containerSelectAll} onPress={wrapAction(cb)}>
	<View>
	  {
	  active_display_list === true
	  ? <CheckNotActivePicto isHeader={true} style={{width:26,height:26}} />
	  : <CheckActivePicto isHeader={true} style={{width:26,height:26}} />
	  }
	</View>
	<Text style={styles.selectAllText}>
	  {this.props.t('Show active elements only')}
	</Text>
      </TouchableOpacity>
    }

    render(){
        // avoid at render...
        const { width, height } = this.getDimensions();

        const styles = StyleSheet.create({
            letterContainer :{
                marginLeft:26,
                marginTop:8,
                marginBottom:20
            },
            letter :{
                fontFamily:this.props.theme.fonts.title,
                fontWeight:"600",
                fontSize:15,
                color:this.props.theme.colors.tertiary.black1.value
            },
            menuLetter:{
                fontFamily:this.props.theme.fonts.text,
                color : this.props.theme.colors.primary.blue1.value,
                fontWeight:"600",
                fontSize:11,
            },
            selectAllText : {
                color : this.props.theme.colors.primary.blue1.value,
                fontFamily: this.props.theme.fonts.text,
		marginLeft: 5
            },
            containerSelectAll : wrapStyle({
                borderTopWidth:1,
                borderBottomWidth:1,
                borderColor:this.props.theme.colors.tertiary.black13.value,
                flexDirection:"row",
                alignItems:"center",
                marginVertical:10,
		paddingVertical:10,
                marginHorizontal:20
            })
        });

        const header = (this.props.isUpdate)? (
            <View style={{width:width,alignItems:"center"}}>
            <View style={{width:"90%",height:60,marginHorizontal:10}}>
                <BarreRecherche search={this.search} fullScreen={true} />
            </View>

           { this.renderSelector(styles) }

        </View>) : (  <View style={{width:width,alignItems:"center"}}>
            <View style={{width:"90%",height:60,marginHorizontal:10}}>
                <BarreRecherche search={this.search} fullScreen={true} />
            </View>
        </View> );

        const focusListSet = this.props.focusListSet || [],
              focusListUnSet = this.props.focusListUnSet || [],
              focusList = this.props.focusList || [];

        const notificationListSet = this.props.notificationListSet || [],
              notificationListUnSet = this.props.notificationListUnSet || [],
              notificationList = this.props.notificationList || [];

        return (
            <View style={{minWidth:width,marginBottom:(this.props.isFocus) ? 0 : 60 }}>
                <KeyboardAvoidingView style={{flex:1,width:width}} enabled={false} behavior={"height"}>
                    <LexicalSectionList
                        listHeaderHeight={16}
                        style={{marginRight:5,height : height-202,minWidth:width}}
                        stickyHeader={false}
                        itemHeight={90}
                        ListEmptyComponent={this.renderEmptyContainer(width, height)}
                        ListHeaderComponent={header}
                        renderSectionHeader={({ section: { title } }) => <View style={styles.letterContainer}><Text style={styles.letter}>{title}</Text></View>}
                        renderItem={({ item }) =>{

                            return (
                            <TendancetListItem
                                type={this.props.type}

                                setFocusList={this.props.setFocusList}
                                isInFocusSetList={focusListSet.some(x=> x.id == item.id)}
                                isInFocusUnSetList={focusListUnSet.some(x => x.id == item.id)}
                                isFocused={focusList.some(x => x.id == item.id)}

                                isInNotificationSetList={notificationListSet.some(x=> x.id == item.id)}
                                isInNotificationUnSetList={notificationListUnSet.some(x => x.id == item.id)}
                                isNotification={notificationList.some(x => x.id == item.id)}
                                setNotificationList={this.props.setNotificationList}

                                isUpdate={this.props.isUpdate}
                                isFocus={this.props.isFocus}
                                key={item.id}
                                isEntity={this.props.isEntity}
                                refNavigation={this.props.refNavigation}
                                hideArticle={true}
                                isExplorer={this.props.isExplorer}
                                avatar={true}
                                item={item}/>)
                        }
                        }
                        //onScroll={this._onScroll}
                        alphabetListOptions={
                            {itemHeight:18,
                                indicatorTextStyle: {fontFamily:this.props.theme.fonts.title,color:this.props.theme.colors.tertiary.value},
                                indicatorStyle:{backgroundColor :this.props.theme.colors.primary.blue1.value },
                                itemStyle:{fontSize :13,fontFamily:this.props.theme.fonts.text,color : this.props.theme.colors.primary.blue1.value},
                                containerStyle:{marginTop:-100,marginRight:0,padding:7}
                            }
                        }
                        sections={this._formData(this.props.data,parseAccent(this.state.search.toUpperCase()))} />
                </KeyboardAvoidingView>
        </View>
               );
    }
}

function parseAccent(e){
    if(e===null)return null;
    return e.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

const mapStateToProps = (state) => {
    return {
      isDark: state.changeTheme.isDark, theme: state.changeTheme.theme, auth: state.AuthReducer,
      online: state.sw_reducer.online
    };
}

export default compose(withTranslation(),connect(mapStateToProps))(ExplorerContactList);
